import React from 'react';

import CameraRoll from '@mui/icons-material/CameraRoll';
import { styled, Typography, List, ListItem, ListItemIcon, Icon, ListItemText } from '@mui/material';

const PREFIX = 'UnsupportedBrowserLayout';

const classes = {
  root: `${PREFIX}-root`,
  center: `${PREFIX}-center`,
  message: `${PREFIX}-message`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },

  [`& .${classes.center}`]: {
    position: 'absolute',
    top: 'calc(35% - 100px)',
    left: '20%',
    marginRight: '10%',
  },

  [`& .${classes.message}`]: {
    display: 'inline',
    marginTop: '25px',
    marginBottom: '25px',
  }
}));

export default function UnsupportedBrowserLayout() {


  return (
    <Root className={classes.root}>
      <div className={classes.center}>
        <CameraRoll style={{ fontSize: '32px', paddingRight: '16px' }} />
        <Typography variant="h4" className={classes.message}>
          Hmm. We love your retro style, but your browser version isn't
          supported. Here's what works:
        </Typography>
        <List>
          <ListItem button>
            <a
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
              href="https://www.google.com/chrome/"
            >
              <ListItemIcon>
                <Icon className={'fab fa-chrome'} />
              </ListItemIcon>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
              href="https://www.google.com/chrome/"
            >
              <ListItemText primary="Chrome" secondary="Install for free!" />
            </a>
          </ListItem>
          <ListItem button>
            <a
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
              href="https://www.microsoft.com/en-us/windows/microsoft-edge"
            >
              <ListItemIcon>
                <Icon className={'fab fa-edge'} />
              </ListItemIcon>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
              href="https://www.microsoft.com/en-us/windows/microsoft-edge"
            >
              <ListItemText primary="Edge" secondary="Install for free!" />
            </a>
          </ListItem>
          <ListItem button>
            <a
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
              href="https://www.mozilla.org/firefox/all/"
            >
              <ListItemIcon>
                <Icon className={'fab fa-firefox'} />
              </ListItemIcon>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
              href="https://www.mozilla.org/firefox/all/"
            >
              <ListItemText primary="Firefox" secondary="Install for free!" />
            </a>
          </ListItem>
          <ListItem button>
            <a
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
              href="https://support.apple.com/downloads/safari"
            >
              <ListItemIcon>
                <Icon className={'fab fa-safari'} />
              </ListItemIcon>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
              href="https://support.apple.com/downloads/safari"
            >
              <ListItemText primary="Safari" secondary="Install for free!" />
            </a>
          </ListItem>
        </List>
      </div>
    </Root>
  );
}
